import React, { createContext, useState } from 'react';
import FilesToJSON from './file-browser/functions/filesToJson';
// Create the contexts
export const LocationContext = createContext({
  folderChain: [],
  setFolderChain(value) {
    this.folderChain = value;
  },
});

export const FilesContext = createContext({
  files: [],
  resetFileMap(value, parse) {
    this.files = parse ? FilesToJSON(value) : value;
  },
});

export const UserContext = createContext({
  user: null,
  setUserInfo(value) {
    console.log(value)
    this.user = value;
  },
});

// Create the combined provider component
export function ContextProvider({ children }) {
  const [folderChain, setFolderChain] = useState([])
  const [files, resetFileMap] = useState([]);
  const [user, setUserInfo] = useState({});
  return (
    <UserContext.Provider value={{ user, setUserInfo }}>
      <FilesContext.Provider value={{ files, resetFileMap }}>
        <LocationContext.Provider value={{ folderChain, setFolderChain }}>
          {children}
        </LocationContext.Provider>
      </FilesContext.Provider>
    </UserContext.Provider>
  );
}
